import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Box, styled, Typography } from '@mui/material'
import ExternalLink from '@mui/material/Link'
import { StepHeader } from './elements/StepHeader'

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row'
  },
  [theme.breakpoints.up('md')]: {
    paddingRight: '75px',
    gap: '30px'
  },
  [theme.breakpoints.up('lg')]: {
    paddingRight: '140px',
    gap: '80px'
  },
  [theme.breakpoints.up('xl')]: {
    paddingRight: '20px'
  }
})) as typeof Box

const DevicesImage = styled('img')(({ theme }) => ({
  width: '150%',
  transform: 'translateX(-35%)',
  [theme.breakpoints.up('xl')]: {
    width: '100%',
    transform: 'translateX(0px)'
  }
}))

const StoreImage = styled('img')(({ theme }) => ({
  width: '110px',
  [theme.breakpoints.up('md')]: {
    width: '160px'
  },
  [theme.breakpoints.up('lg')]: {
    width: '215px'
  }
}))

export default function Devices() {
  return (
    <Box component="section" sx={{ margin: { xs: '100px 0 80px', lg: '140px 0' } }}>
      <StepHeader step="2" title="Download the app &amp; back up " />
      <Wrapper component="article">
        <Box sx={{ width: { xs: '100%', sm: '40%', md: '50%' }, overflow: 'hidden' }}>
          <picture>
            <DevicesImage
              sizes="(max-width: 1600px) 100vw, 1600px"
              srcSet="
                //content.photobucket.com/img/homepage/homepage-july-2024-devices_w200.webp 200w,
                //content.photobucket.com/img/homepage/homepage-july-2024-devices_w731.webp 731w,
                //content.photobucket.com/img/homepage/homepage-july-2024-devices_w1065.webp 1065w,
                //content.photobucket.com/img/homepage/homepage-july-2024-devices_w1372.webp 1372w,
                //content.photobucket.com/img/homepage/homepage-july-2024-devices_w1600.webp 1600w"
              src="//content.photobucket.com/img/homepage/homepage-july-2024-devices_w1600.webp"
              alt="Views of Photobucket on several devices"
              loading="lazy"
            />
          </picture>
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '60%', md: '50%' }, padding: { xs: '0 10px', md: ' 0 0 20px 0' } }}>
          <Typography
            sx={{
              fontSize: { xs: '1.75rem', md: '2rem', lg: '3rem', xl: '4rem' },
              fontWeight: 600,
              lineHeight: 1.25,
              marginTop: { xs: '20px', md: '60px' }
            }}
          >
            Access all your photos &amp; videos{' '}
            <Box
              component="span"
              sx={{
                background: 'linear-gradient(158.55deg, #202CD3 5.3%, #02E39F 102.34%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                textFillColor: 'transparent'
              }}
            >
              anytime on any device.
            </Box>
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: '1rem', lg: '1.375rem', xl: '1.75rem' },
              fontFamily: '"proxima-nova", sans-serif',
              lineHeight: 1.5,
              margin: { xs: '20px 0', lg: '40px 0' }
            }}
          >
            Built for people on the go, with the Photobucket app for Android or iOS, you can automatically backup every photo you take on your phone
            then access them on your desktop, tablet and other devices. It&apos;s that simple.
          </Typography>
          <Box sx={{ display: 'flex', gap: '10px', marginBottom: { xs: '20px', lg: '40px' } }}>
            <ExternalLink
              href="https://apps.apple.com/us/app/photobucket-backup/id314439840?utm_medium=web&utm_source=discount_page&utm_content=device_block&utm_campaign=v2_apple"
              data-test="ios-app-store-badge"
            >
              <StoreImage src="//content.photobucket.com/img/homepage/app-store-black.webp" alt="App Store" loading="lazy" />
            </ExternalLink>
            <ExternalLink
              href="https://play.google.com/store/apps/details?id=com.photobucket.android&utm_medium=web&utm_source=discount_page&utm_content=device_block&utm_campaign=v2_android"
              data-test="android-app-store-badge"
            >
              <StoreImage src="//content.photobucket.com/img/homepage/google-play-black.webp" alt="Google Play" loading="lazy" />
            </ExternalLink>
          </Box>
          <ExternalLink
            href="/offer/app"
            data-test="devices-learn-more"
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: '#1C47CB',
              fontFamily: '"proxima-nova", sans-serif',
              fontSize: { xs: '0.875rem', md: '1.125rem', lg: '1.375rem', xl: '1.5rem' },
              fontWeight: '600',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              textDecoration: 'none',
              '&:hover': {
                color: '#101828'
              }
            }}
          >
            Learn More <ArrowForwardIcon sx={{ marginLeft: '5px', fontSize: { xs: '1rem', md: '1.125rem', lg: '2rem' } }} />
          </ExternalLink>
        </Box>
      </Wrapper>
    </Box>
  )
}
